import React from "react";
import { Target, Eye, BadgeCheck, MapPin } from "lucide-react";
import { useSite } from "../components/SiteLayout";

export default function SiteAbout() {
  const site = useSite();
  const name = site.institute_name || "Lovely Institute";

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-12" data-testid="site-about">
      <div className="text-xs uppercase tracking-widest text-blue-800 font-semibold mb-1">About Us</div>
      <h1 className="font-display text-3xl sm:text-4xl font-bold text-slate-900 mb-8">{name}</h1>

      {site.about_text && (
        <section className="mb-8">
          <h2 className="font-display text-xl font-bold text-slate-900 mb-2">About the Institute</h2>
          <p className="text-slate-600 leading-relaxed whitespace-pre-line" data-testid="about-text">
            {site.about_text}
          </p>
        </section>
      )}

      {(site.mission || site.vision) && (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-8">
          {site.mission && (
            <div className="rounded-xl border border-slate-200 bg-white p-6" data-testid="about-mission">
              <div className="w-10 h-10 rounded-lg bg-blue-800 text-white grid place-items-center mb-3">
                <Target size={18} />
              </div>
              <h2 className="font-display text-lg font-bold text-slate-900 mb-1.5">Our Mission</h2>
              <p className="text-sm text-slate-600 leading-relaxed whitespace-pre-line">{site.mission}</p>
            </div>
          )}
          {site.vision && (
            <div className="rounded-xl border border-slate-200 bg-white p-6" data-testid="about-vision">
              <div className="w-10 h-10 rounded-lg bg-blue-800 text-white grid place-items-center mb-3">
                <Eye size={18} />
              </div>
              <h2 className="font-display text-lg font-bold text-slate-900 mb-1.5">Our Vision</h2>
              <p className="text-sm text-slate-600 leading-relaxed whitespace-pre-line">{site.vision}</p>
            </div>
          )}
        </div>
      )}

      <div className="rounded-xl border border-slate-200 bg-white p-6 space-y-3" data-testid="about-info">
        <h2 className="font-display text-lg font-bold text-slate-900">Institute Information</h2>
        {site.registration_info && (
          <div className="flex items-start gap-2.5 text-sm text-slate-600">
            <BadgeCheck size={16} className="text-blue-800 shrink-0 mt-0.5" />
            <span data-testid="about-registration">{site.registration_info}</span>
          </div>
        )}
        {site.address && (
          <div className="flex items-start gap-2.5 text-sm text-slate-600">
            <MapPin size={16} className="text-blue-800 shrink-0 mt-0.5" />
            <span>{site.address}</span>
          </div>
        )}
        {!site.about_text && !site.mission && !site.vision && !site.registration_info && (
          <p className="text-sm text-slate-400">
            Institute information will appear here once configured by the administrator.
          </p>
        )}
      </div>
    </div>
  );
}
